import { quellZeit, rampeVon } from './rampe.js';
export function teileClip(clip, lokal) {
    const r = rampeVon(clip);
    const anStelle = r.von + ((r.bis - r.von) * lokal) / clip.duration;
    const rampe = Math.abs(r.bis - r.von) > 1e-9;
    return {
        links: { duration: lokal, speedBis: rampe ? anStelle : clip.speedBis ?? null },
        rechts: {
            start: clip.start + lokal,
            duration: clip.duration - lokal,
            sourceIn: clip.sourceIn + quellZeit(lokal, clip.duration, r),
            speed: rampe ? anStelle : clip.speed,
            speedBis: rampe ? r.bis : clip.speedBis ?? null,
        },
    };
}
//# sourceMappingURL=teilen.js.map